var React = require('react');

function Blob (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.99923 81.4017C-10.3769 137.128 17.417 192.663 66.2959 205.068C115.175 217.472 166.354 182.357 180.73 126.631C195.106 70.9054 167.312 15.3702 118.434 2.96547C69.5545 -9.63013 18.3754 25.4849 3.99923 81.4017Z","fill":"currentColor"}));
}

Blob.defaultProps = {"viewBox":"0 0 185 208","fill":"none"};

module.exports = Blob;

Blob.default = Blob;
